import PropTypes from 'prop-types';
import React from 'react';

import FullWidthCard from '../../components/cards/FullWidthCard';

const ComposableVideoPortalCard = (props) => {
  const { slug: key } = props;
  return <FullWidthCard key={key} {...props} />;
};

ComposableVideoPortalCard.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default ComposableVideoPortalCard;
